<mat-icon (click)="openDialog()">edit</mat-icon>
